import Calendar from '../components/Calendar'
import DashboardCircles from '../components/DashboardCircles'

export default class Territories {
  constructor(params) {
    this.params = params
  }

  show() {
    if ($(".area-director").length === 1) {
      this.areaDirector();
      $(".dashboard-circles").each((i, el) => {
        new DashboardCircles(el);
      });
    }
  }

  unload() {
    return this.calendar && this.calendar.unload();
  }

  areaDirector() {
    var $adj, $circles, $guide, $pubs, filterApplied;
    this.calendar = Calendar.init('#main-calendar');
    this.calendar.hideNextPrev();
    this.resizeDashboardGuide();
    $adj = $(".ad-design-jobs");
    $circles = $(".dashboard-circle");
    $pubs = $(".dashboard-publications");
    $guide = $(".dashboard-guide");
    filterApplied = false;
    $circles.each(function(i, el) {
      var $circle;
      $circle = $(el);
      return $circle.on("click", function() {
        var status;
        status = $circle.data("status");
        $circles.addClass("disable");
        $pubs.addClass("disable");
        $circle.removeClass("disable");
        $guide.find("h2").hide();
        $guide.find("h2.ads-" + status).css({
          display: "inline-block"
        });
        $adj[0].className = "ad-design-jobs filter-" + status;
        return filterApplied = true;
      });
    });

    return N2.bindHandler("click", '*', function(e) {
      if (filterApplied && $(e.target).parents(".dashboard-circle, .ad-design-jobs").length === 0) {
        $circles.removeClass("disable");
        $pubs.removeClass("disable");
        $guide.find("h2").hide();
        $guide.find("h2.territory-selected").css({
          display: "inline-block"
        });
        $adj[0].className = "ad-design-jobs";
        return filterApplied = false;
      }
    });
  }

  resizeDashboardGuide() {
    var height;
    height = $(".dashboard-greeting").height();
    return $(".dashboard-guide").css({
      height: height,
      lineHeight: height + "px"
    });
  }
}
